import { validate, version } from 'uuid';

export const isValidUuid = (input: string): boolean => validate(input) && version(input) === 4;
